import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_ACTIVATION_GET_TYPES_LIST } from 'api/utilityActionTypes';

export default async function getTypesList(
  { state, utilityApiClient },
  { partnerId, forceRefresh = false } = {},
) {
  typeCheck('partnerId::Maybe PositiveNumber', partnerId);
  typeCheck('forceRefresh::Maybe Boolean', forceRefresh);

  const statePath = partnerId
    ? ['utilityActivations', 'typesByPartnerId', partnerId]
    : ['utilityActivations', 'types'];

  const typesCache = state.get(statePath);
  if (typesCache && !forceRefresh) {
    return typesCache;
  }

  await utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_ACTIVATION_GET_TYPES_LIST,
    state: state,
    payload: { partnerId },
    onSuccess(utilityTypes) {
      if (utilityTypes) {
        state.set(statePath, utilityTypes);
        return utilityTypes;
      }
    },
  });
}
